import * as Yup from 'yup';

import { AlfaLeasingFormFields, AlfaLeasingFormProps } from './types';

export const approvedLeasingTitle = 'Лизинг предварительно одобрен';
export const approvedLeasingText =
  'Поздравляем! \n' +
  'Осталось отправить заявку. \n' +
  'В ближайшее время с вами \n' +
  'свяжется специалист.';

export const notApprovedLeasingTitle = 'Требуются уточнения';
export const notApprovedLeasingText =
  'Требуется больше информации \n' +
  'для предоставления лизинга.\n' +
  'С вами свяжется наш специалист.';

export const getDefaultValues = (
  options: Pick<AlfaLeasingFormProps, 'dealers'>
): AlfaLeasingFormFields => {
  const dealer =
    options.dealers.length === 1
      ? options.dealers[0]
      : initialAlfaLeasingFormValues.dealer;

  return {
    ...initialAlfaLeasingFormValues,
    dealer,
  };
};

export const initialAlfaLeasingFormValues: AlfaLeasingFormFields = {
  name: '',
  phone: '',
  dealer: { label: '', value: '' },
};

export const validationAlfaLeasingFormSchema: Yup.SchemaOf<AlfaLeasingFormFields> =
  Yup.object().shape({
    name: Yup.string().required('Укажите имя'),
    phone: Yup.string().required('Укажите номер телефона'),
    dealer: Yup.object({
      label: Yup.string().required('Выберите автоцентр'),
      value: Yup.string().required('Выберите автоцентр'),
    }),
  });
